const TYPE_MUSIC = 'song'
const TYPE_MARKETING = 'advertisement'
const TYPE_PA = 'announcement'

const emptyModel = {
  artist: null,
  title: null
}

const emptyFilters = {
  search: undefined,
  attributes: {}
}

export default {
  TYPE_MUSIC,
  TYPE_MARKETING,
  TYPE_PA,
  emptyModel,
  emptyFilters
}
